<script setup lang="ts">
import { useTheme } from 'vuetify'
import AppSnackbar from '@/components/AppSnackbar.vue'
import ScrollToTop from '@core/components/ScrollToTop.vue'
import initCore from '@core/initCore'
import { initConfigStore, useConfigStore } from '@core/stores/config'
import { hexToRgb } from '@core/utils/colorConverter'

const { global } = useTheme()

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const configStore = useConfigStore()
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView />

      <!-- Avisos de resultado de una acción (guardar, borrar, publicar). Va acá
           para que salga igual en cualquier layout. -->
      <AppSnackbar />

      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
